//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { zdsCategory } from "./../../config/env";
import { getOrderDetail } from "@/service/index";
const AuditStatus = ["未审核", "已审核"];
export default {
  data() {
    return {
      zdsCategory: zdsCategory,
      Detail: {},
    };
  },
  components: {},
  created() {
    this.getOrderDetail();
  },
  mounted() {},
  watch: {
    $route: function (to, from) {},
  },
  methods: {
    getOrderDetail() {
      let vm = this;
      getOrderDetail(this.$route.params.id, (result) => {
        if (result.code === "1") {
          vm.Detail = JSON.parse(result.data);
          // console.log(vm.Detail)
          vm.Detail.AuditStatus = AuditStatus[vm.Detail.AuditStatus];
          if (vm.Detail.BigCategory === vm.zdsCategory.ZSQ) {
            vm.Detail.CageName = "镶嵌类";
          } else if (vm.Detail.BigCategory === vm.zdsCategory.ZSJ) {
            vm.Detail.CageName = "素金类";
          } else if (vm.Detail.BigCategory === vm.zdsCategory.ZYHP) {
            vm.Detail.CageName = "易耗品";
          }
        }
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/page/order/orderdetail.vue